import React from "react";
import { LINECHART_THEME } from "./useLineChartTheme";

export const LineChartThemeContext = React.createContext({ THEME: LINECHART_THEME.DEFAULT });